import { UpdateUserDataRequestTypes } from '../_types/updateUserDataRequest.types';
import { apiUserAccount } from '../../../utils/ApiService';
import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

export const accountService = {
  
  updateUserData: async (data: UpdateUserDataRequestTypes): Promise<void> => {
    const schemaId = getSchemaIdFromStorage();
    
    try {
      await apiUserAccount.put(`${ApiEndpoints.account.updateMe}?schemaId=${schemaId}`, data);
    } catch (error) {
      throw error;
    }
  }
};
